import classNames from 'classnames';
import { useTranslations } from 'next-intl';

interface CancelBtnProps {
  onCancel: (() => void) | null;
}

export const CancelBtn: React.FC<CancelBtnProps> = ({ onCancel }) => {
  const t = useTranslations();

  if (!onCancel) return null;

  return (
    <button type="button" className={styles.btn.cancel} onClick={onCancel}>
      {t('common.cancel')}
    </button>
  );
};

const styles = {
  btn: {
    cancel: classNames(
      'bg-surface-card py-2 px-4 border border-stroke rounded-full shadow-xs text-[13px] font-medium text-ink-primary',
      'hover:bg-surface-field focus:outline-hidden mr-3',
    ),
  },
};
